import React from 'react';
import PropTypes from 'prop-types';

import InscricaoDetalhes from './InscricaoDetalhes';
import PrincipalMaster from '../master/Principal';
import PublicMaster from '../master/Public';
import { Utils, autorService } from '../../services';

const InscricaoStepFinalizar = (props) => {
    const MasterPage = Utils.getUsuarioEstaLogado() ? PrincipalMaster : PublicMaster;

    if (props.match.params.autor) {
        const autorPromise = autorService.aceitaTermo(props.match.params.autor, props.match.params.codigoProjeto);
        Promise.all([autorPromise]);
    }
    return (
        <MasterPage title="Detalhes do projeto">
            <InscricaoDetalhes codigoProjeto={props.match.params.codigoProjeto} />
        </MasterPage>
    );
};

InscricaoStepFinalizar.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            codigoProjeto: PropTypes.string,
        }),
    }).isRequired,
};

export default InscricaoStepFinalizar;
